import "./LegalNotice.module.css";
import Header from "@/reusable_sections/Header";
import CompanyInformation from "./sections/CompanyInformation";
import LegalInformation from "./sections/LegalInformation";
import Footer from "@/reusable_sections/Footer";
export default function LegalNoticePage() {
  return <div>
      <Header />
      <CompanyInformation />
      <LegalInformation />
      <Footer />
    </div>;
}